import { Controller, FieldErrors, useFormContext } from "react-hook-form";
import { DropdownSelect, ErrorMessage, Typography } from "@/components/atoms";
import { getRegistrationTypeOptions } from "@/helpers/registrationValidators";
import { useCountryConfig, useOperator } from "@/hooks";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const BusinessRegistrationTypeField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();
  const { country: operatorCountry } = useOperator();
  const country = watch("countryCode") ?? operatorCountry;
  const { config } = useCountryConfig(country);

  /** Which types a country accepts is country data; each type's label comes from the registry. */
  const options = getRegistrationTypeOptions(config.businessRegistrationTypes);

  return (
    <div className={clsx("flex flex-col gap-1", className)} {...props}>
      <Typography>Business Registration Type</Typography>
      <Controller
        control={control}
        name="businessRegistration.businessRegistrationType"
        render={({ field }) => (
          <DropdownSelect
            className="w-full"
            placeholder="Select Type"
            options={options}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
              clearErrors("businessRegistration.businessRegistrationIdNumber");
            }}
            hasError={!!errors.businessRegistration?.businessRegistrationType}
          />
        )}
      />
      {errors.businessRegistration?.businessRegistrationType && (
        <ErrorMessage errors={errors.businessRegistration as FieldErrors} name="businessRegistrationType" />
      )}
    </div>
  );
};
